<template>
  <Modal
    open
    @close="handleCancelButtonClick"
    size="small"
    :hideScrollbar="true"
    class="[&_.modal-position]:!items-start [&_.modal-position]:!px-6 [&_.modal-position]:!pt-32"
    :roundedOnMobile="true"
  >
    <div
      v-if="props.event_quick_register"
      class="m-5 flex flex-col items-center bg-white text-center sm:m-9 sm:mt-3 sm:rounded-lg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
      >
        <mask
          id="mask0_4908_48300"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="60"
          height="60"
        >
          <rect width="60" height="60" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4908_48300)">
          <path
            d="M27.375 45L41.5 30.875L37.875 27.25L27.3125 37.8125L22.0625 32.5625L18.5 36.125L27.375 45ZM15 55C13.625 55 12.4479 54.5104 11.4688 53.5312C10.4896 52.5521 10 51.375 10 50V10C10 8.625 10.4896 7.44792 11.4688 6.46875C12.4479 5.48958 13.625 5 15 5H35L50 20V50C50 51.375 49.5104 52.5521 48.5312 53.5312C47.5521 54.5104 46.375 55 45 55H15ZM32.5 22.5H45L32.5 10V22.5Z"
            fill="#10B981"
          />
        </g>
      </svg>
      <div class="mt-4 flex flex-col items-center justify-center">
        <h2
          class="h-auto px-0 text-center text-xl font-medium text-gray-900 sm:px-12 sm:text-2xl"
        >
          {{ __("You've successfully registered for the event.") }}
        </h2>

        <p class="mt-2 w-full text-base text-gray-800">
          {{ __('Feel free to start onboarding now.') }}
        </p>
      </div>
      <div
        class="mt-8 flex flex-col items-center md:flex-row-reverse md:justify-center"
      >
        <Button
          class="flex items-center justify-center gap-1.5"
          type="button"
          tabindex="-1"
          style="width: 10rem !important"
          @click="handleCancelButtonClick"
        >
          <span>{{ __("Let's start") }}</span>
        </Button>
      </div>
    </div>

    <div
      v-else-if="props.event_quick_register_fail"
      class="m-5 flex flex-col items-center bg-white text-center sm:m-9 sm:rounded-lg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
      >
        <path
          d="M33.75 22.5C34.7917 22.5 35.6771 22.1354 36.4062 21.4062C37.1354 20.6771 37.5 19.7917 37.5 18.75C37.5 17.7083 37.1354 16.8229 36.4062 16.0938C35.6771 15.3646 34.7917 15 33.75 15C32.7083 15 31.8229 15.3646 31.0938 16.0938C30.3646 16.8229 30 17.7083 30 18.75C30 19.7917 30.3646 20.6771 31.0938 21.4062C31.8229 22.1354 32.7083 22.5 33.75 22.5ZM16.25 22.5C17.2917 22.5 18.1771 22.1354 18.9062 21.4062C19.6354 20.6771 20 19.7917 20 18.75C20 17.7083 19.6354 16.8229 18.9062 16.0938C18.1771 15.3646 17.2917 15 16.25 15C15.2083 15 14.3229 15.3646 13.5938 16.0938C12.8646 16.8229 12.5 17.7083 12.5 18.75C12.5 19.7917 12.8646 20.6771 13.5938 21.4062C14.3229 22.1354 15.2083 22.5 16.25 22.5ZM25 28.75C22.1667 28.75 19.5938 29.5521 17.2812 31.1563C14.9688 32.7604 13.2917 34.875 12.25 37.5H16.375C17.2917 35.9583 18.5104 34.7396 20.0312 33.8438C21.5521 32.9479 23.2083 32.5 25 32.5C26.7917 32.5 28.4479 32.9479 29.9688 33.8438C31.4896 34.7396 32.7083 35.9583 33.625 37.5H37.75C36.7083 34.875 35.0312 32.7604 32.7188 31.1563C30.4063 29.5521 27.8333 28.75 25 28.75ZM25 50C21.5417 50 18.2917 49.3438 15.25 48.0312C12.2083 46.7188 9.5625 44.9375 7.3125 42.6875C5.0625 40.4375 3.28125 37.7917 1.96875 34.75C0.65625 31.7083 0 28.4583 0 25C0 21.5417 0.65625 18.2917 1.96875 15.25C3.28125 12.2083 5.0625 9.5625 7.3125 7.3125C9.5625 5.0625 12.2083 3.28125 15.25 1.96875C18.2917 0.65625 21.5417 0 25 0C28.4583 0 31.7083 0.65625 34.75 1.96875C37.7917 3.28125 40.4375 5.0625 42.6875 7.3125C44.9375 9.5625 46.7188 12.2083 48.0312 15.25C49.3438 18.2917 50 21.5417 50 25C50 28.4583 49.3438 31.7083 48.0312 34.75C46.7188 37.7917 44.9375 40.4375 42.6875 42.6875C40.4375 44.9375 37.7917 46.7188 34.75 48.0312C31.7083 49.3438 28.4583 50 25 50Z"
          fill="#D71F70"
        />
      </svg>
      <div class="mt-4 flex flex-col items-center justify-center">
        <h2
          class="h-auto text-center text-xl font-medium text-gray-900 sm:text-2xl"
        >
          {{ __('This event is no longer available.') }}
        </h2>

        <p class="mt-2 w-full text-base text-gray-800">
          {{
            __(
              "Welcome aboard! Your account is validated and you're ready to explore our platform."
            )
          }}
        </p>
      </div>
      <div
        class="mt-8 flex flex-col items-center md:flex-row-reverse md:justify-center"
      >
        <Button
          class="flex items-center justify-center gap-1.5"
          type="button"
          tabindex="-1"
          @click="handleCancelButtonClick"
        >
          <span>{{ __('Complete the Onboarding to Unlock More') }}</span>
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script setup>
  import { computed } from 'vue';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import Modal from '../../../../../components/block/modal/modal.vue';

  const props = defineProps({
    event_quick_register: Number,
    event_quick_register_fail: String
  });
  const emits = defineEmits(['cancel']);

  function handleCancelButtonClick() {
    emits('cancel');
  }
</script>
